import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";
import {IMarketingPage} from "../marketing-page.models";
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {IShopUser} from "../../session/customer-models";
import * as _ from "lodash";
import {TranslateService} from "../../translation/translate.service";
import {ActivatedRoute} from "@angular/router";
import {LocaleUtil} from "../../util/locale-util";
import {MarketingPageService} from "../marketing-page.service";
import {ILocaleProperties} from "../../locale/locale-models";

@Component({
    selector: 'page-preview',
    templateUrl: './page-preview.component.html',
    styleUrls: ['./page-preview.component.scss'],
    standalone: false
})
export class PagePreviewComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() pageName: string;
    @Input() pageType: string;
    @Output() readonly clearPageEvent = new EventEmitter();
    @Output() readonly setPageEvent = new EventEmitter<IMarketingPage>();

    marketingPageId: string;
    showPreviewPage: boolean = false;
    previewCountry: string;
    previewLanguage: string;
    previewDate: Date;
    currentCountry: string;
    currentLanguage: string;
    currentDate: Date;

    constructor(
        userService: UserService,
        loggerService: LoggerService,
        private route: ActivatedRoute,
        private translateService: TranslateService,
        private marketingPageService: MarketingPageService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.getCustomerData().then((user: IShopUser) => { // base component attributes are not available in ngOnInit on child component
            this.initPreviewPage(user);
        });
    }

    ngOnDestroy() {
        if (this.showPreviewPage) {
            this.closePreviewPage();
        }
    }

    get currentLocale(): string {
        return LocaleUtil.buildLocale(this.currentLanguage?.toLowerCase(), this.currentCountry?.toUpperCase(), LocaleUtil.USANA_LOCALE_SEPARATOR);
    }

    initPreviewPage(user: IShopUser) {
        // previewPage only accessible to employees through Routes
        const urlParamId: string = this.route.snapshot.paramMap.get("uniqueId");
        if (!!urlParamId && this.employee) {
            this.marketingPageId = urlParamId;

            this.currentCountry = _.clone(user.currentCountry);
            this.currentLanguage = _.clone(user.customer.language);
            this.previewCountry = this.currentCountry;
            this.previewLanguage = this.currentLanguage;

            this.currentDate = new Date();
            this.previewDate = new Date();
            this.previewDate.setHours(0);
            this.previewDate.setMinutes(1);
            this.previewDate.setSeconds(0);
            this.translateService.resetAlternateLocale();
            this.showPreviewPage = true;
        }
    }

    setPreviewPage() {
        this.clearPageEvent.emit();
        if (this.showPreviewPage && (this.previewCountry !== this.currentCountry || this.previewLanguage !== this.currentLanguage)) {
            this.translateService.setAlternateLocale({
                    country: this.previewCountry?.toUpperCase(),
                    language: this.previewLanguage?.toLowerCase(),
                    usanaLocale: LocaleUtil.buildLocale(this.previewLanguage?.toLowerCase(), this.previewCountry?.toUpperCase(), LocaleUtil.USANA_LOCALE_SEPARATOR)
                } as ILocaleProperties
            );
        }

        this.marketingPageService.getPreviewPage(this.marketingPageId, this.previewDate.getTime().toString(), this.pageType, this.previewCountry).subscribe((page: IMarketingPage) => {
            this.setPageEvent.emit(page);
            this.currentCountry = this.previewCountry;
            this.currentLanguage = this.previewLanguage;
            this.currentDate = this.previewDate;
        });
    }

    closePreviewPage() {
        this.showPreviewPage = false;
        this.translateService.resetAlternateLocale();
    }
}
